import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import coachnowMark from "app/images/logo-orange-144x144.png";
import { completedCount } from "app/components/AcademySetup/items";
import useAcademySetupItems from "app/utils/hooks/useAcademySetupItems";
import { trackDemoBannerClicked } from "app/utils/analytics-helpers";
import { BOOK_A_DEMO_URL } from "../../faq";
import styles from "./styles.module.scss";

const BookDemoBanner = () => {
  const { t } = useTranslation();
  const { items, loaded } = useAcademySetupItems();
  // A click before the checklist has loaded is reported once the count is
  // real rather than with the placeholder's 0.
  const clickedBeforeLoad = useRef(false);
  useEffect(() => {
    if (loaded && clickedBeforeLoad.current) {
      clickedBeforeLoad.current = false;
      trackDemoBannerClicked(completedCount(items));
    }
  }, [loaded, items]);
  const onClick = () => {
    if (loaded) {
      trackDemoBannerClicked(completedCount(items));
    } else {
      clickedBeforeLoad.current = true;
    }
  };

  return (
    <div className={styles.container}>
      <img className={styles.mark} src={coachnowMark} alt="" />
      <div className={styles.text}>
        <p className={styles.title}>{t("Get a Custom CoachNow Demo")}</p>
        <p className={styles.subtitle}>
          {t(
            "In this one-on-one session, a Head Coach will spend time understanding your business and goals.",
          )}
        </p>
      </div>
      <a
        className={styles.demo_button}
        href={BOOK_A_DEMO_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {t("Book a Demo")}
      </a>
    </div>
  );
};

export default BookDemoBanner;
